import React from "react";
import { FaFilePdf, FaFileImage, FaUser, FaEnvelope, FaPhone, FaLock, FaCalendar, FaGlobe, FaMapMarkerAlt, FaIdCard, FaBuilding, FaMap, FaVenusMars } from "react-icons/fa";

const modernStyles = `
  .premium-form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    margin-top: 10px;
  }
  
  .premium-form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
    position: relative;
  }

  .premium-form-group.full-width {
    grid-column: 1 / -1;
  }

  .premium-label {
    font-size: 14px;
    font-weight: 700;
    color: #334155;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-family: 'Inter', sans-serif;
  }

  .premium-input, .premium-select {
    padding: 14px 18px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    font-size: 15px;
    font-family: 'Inter', sans-serif;
    color: #0f172a;
    background-color: #ffffff;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .premium-input:focus, .premium-select:focus {
    outline: none;
    border-color: #3b82f6;
    background-color: #fff;
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
  }

  .premium-file-label {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 16px;
    background: #ffffff;
    border: 2px dashed #cbd5e1;
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    font-weight: 600;
    color: #475569;
  }

  .premium-file-label:hover {
    border-color: #3b82f6;
    background: #f0f7ff;
    color: #2563eb;
    transform: translateY(-2px);
  }

  .phone-input-wrapper {
    display: flex;
    gap: 12px;
  }

  .phone-input-wrapper select {
    flex: 0 0 110px;
  }
  
  .phone-input-wrapper input {
    flex: 1;
  }

  @media (max-width: 768px) {
    .premium-form-grid {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }
`;

// Helper component for standard fields
const Field = ({ label, icon, fullWidth, children }) => (
    <div className={`premium-form-group ${fullWidth ? 'full-width' : ''}`}>
        <label className="premium-label">{icon}{label}</label>
        {children}
    </div>
);

// 1. Fields for Traveler
const TravelerFields = ({ nationalities, countries, genders, handleChange, formData }) => (
    <>
        <style>{modernStyles}</style>
        <div className="premium-form-grid">
            <Field label="Full Name *" icon={<FaUser color="#6366f1"/>} fullWidth>
                <input type="text" name="full_name" className="premium-input" placeholder="Jone Doe" onChange={handleChange} required />
            </Field>

            <Field label="Email Address *" icon={<FaEnvelope color="#6366f1"/>}>
                <input type="email" name="email" className="premium-input" placeholder="m@example.com" onChange={handleChange} required />
            </Field>

            <Field label="Phone Number *" icon={<FaPhone color="#6366f1"/>}>
                <div className="phone-input-wrapper">
                    <select className="premium-select" style={{ minWidth: '130px' }} defaultValue="+94"> 
                        <option value="+94">🇱🇰 +94 (SL)</option>
                        <option value="+1">🇺🇸 +1 (US/CA)</option>
                        <option value="+44">🇬🇧 +44 (UK)</option>
                        <option value="+61">🇦🇺 +61 (AU)</option>
                        <option value="+49">🇩🇪 +49 (DE)</option>
                        <option value="+33">🇫🇷 +33 (FR)</option>
                        <option value="+91">🇮🇳 +91 (IN)</option>
                        <option value="+81">🇯🇵 +81 (JP)</option>
                        <option value="+86">🇨🇳 +86 (CN)</option>
                        <option value="+971">🇦🇪 +971 (UAE)</option>
                        <option value="+966">🇸🇦 +966 (SA)</option>
                        <option value="+65">🇸🇬 +65 (SG)</option>
                        <option value="+60">🇲🇾 +60 (MY)</option>
                        <option value="+7">🇷🇺 +7 (RU)</option>
                        <option value="+39">🇮🇹 +39 (IT)</option>
                        <option value="+34">🇪🇸 +34 (ES)</option>
                        <option value="+31">🇳🇱 +31 (NL)</option>
                        <option value="+41">🇨🇭 +41 (CH)</option>
                        <option value="+82">🇰🇷 +82 (KR)</option>
                        <option value="+64">🇳🇿 +64 (NZ)</option>
                        <option value="+974">🇶🇦 +974 (QA)</option>
                        <option value="+965">🇰🇼 +965 (KW)</option>
                        <option value="+968">🇴🇲 +968 (OM)</option>
                        <option value="+973">🇧🇭 +973 (BH)</option>
                        <option value="+960">🇲🇻 +960 (MV)</option>
                        <option value="+880">🇧🇩 +880 (BD)</option>
                        <option value="+977">🇳🇵 +977 (NP)</option>
                        <option value="+27">🇿🇦 +27 (ZA)</option>
                        <option value="+other">🌐 Other</option>
                    </select>
                    <input type="tel" name="phone_number" className="premium-input" placeholder="e.g. 771234567 or full number" onChange={handleChange} required />
                </div>
            </Field>

            <Field label="Password *" icon={<FaLock color="#6366f1"/>}>
                <input type="password" name="password" className="premium-input" placeholder="Enter password" onChange={handleChange} required />
            </Field>

            <Field label="Date of Birth *" icon={<FaCalendar color="#6366f1"/>}>
                <input type="date" name="dob" className="premium-input" onChange={handleChange} required />
            </Field>

            <Field label="Nationality *" icon={<FaGlobe color="#6366f1"/>}>
                <select name="nationality_id" className="premium-select" onChange={handleChange} required>
                    <option value="">Select your nationality</option>
                    {nationalities.map((n) => (<option key={n.id} value={n.id}>{n.name}</option>))}
                </select>
            </Field>

            <Field label="Country *" icon={<FaMapMarkerAlt color="#6366f1"/>}>
                <select name="country_id" className="premium-select" onChange={handleChange} required>
                    <option value="">Select your country</option>
                    {countries.map((c) => (<option key={c.id} value={c.id}>{c.name}</option>))}
                </select>
            </Field>

            <Field label="Gender *" icon={<FaVenusMars color="#6366f1"/>}>
                <select name="gender_id" className="premium-select" onChange={handleChange} required>
                    <option value="">Select gender</option>
                    {genders.map((g) => (<option key={g.id} value={g.id}>{g.name}</option>))}
                </select>
            </Field>

            <Field label="Referral Code (Optional)" icon={<FaIdCard color="#6366f1"/>}>
                <input type="text" name="referral_code" className="premium-input" placeholder="Enter referral code" value={formData.referral_code} onChange={handleChange} />
            </Field>
        </div>
    </>
);

// 2. Fields for Guide
const GuideFields = ({
    formData,
    nationalities,
    countries,
    genders,
    districts,
    registrationName,
    nicFrontName,
    nicBackName,
    billFrontName,
    billBackName,
    handleChange,
    handleFileChange
}) => (
    <>
        <style>{modernStyles}</style>
        <div className="premium-form-grid">
            <Field label="Full Name *" icon={<FaUser color="#10b981"/>} fullWidth>
                <input type="text" name="full_name" className="premium-input" placeholder="Jone Doe" onChange={handleChange} required />
            </Field>
            
            <Field label="Email Address *" icon={<FaEnvelope color="#10b981"/>}>
                <input type="email" name="email" className="premium-input" placeholder="m@example.com" onChange={handleChange} required />
            </Field>

            <Field label="Phone Number *" icon={<FaPhone color="#10b981"/>}>
                <div className="phone-input-wrapper">
                    <select className="premium-select"><option value="+94">SL +94</option></select>
                    <input type="tel" name="phone_number" className="premium-input" placeholder="Phone number" onChange={handleChange} required />
                </div>
            </Field>

            <Field label="Password *" icon={<FaLock color="#10b981"/>}>
                <input type="password" name="password" className="premium-input" placeholder="Password" onChange={handleChange} required />
            </Field>

            <Field label="Date of Birth *" icon={<FaCalendar color="#10b981"/>}>
                <input type="date" name="dob" className="premium-input" onChange={handleChange} required />
            </Field>

            <Field label="National ID *" icon={<FaIdCard color="#10b981"/>}>
                <input type="text" name="national_id" className="premium-input" placeholder="National ID" onChange={handleChange} required />
            </Field>
            
            <Field label="Address *" icon={<FaMapMarkerAlt color="#10b981"/>} fullWidth>
                <input type="text" name="address" className="premium-input" placeholder="Full address" onChange={handleChange} required />
            </Field>

            <Field label="City *" icon={<FaBuilding color="#10b981"/>}>
                <input type="text" name="city" className="premium-input" placeholder="City" onChange={handleChange} required />
            </Field>
            
            <Field label="Zip Code *" icon={<FaMap color="#10b981"/>}>
                <input type="text" name="zip_code" className="premium-input" placeholder="Zip code" onChange={handleChange} required />
            </Field>

            <Field label="District *" icon={<FaMapMarkerAlt color="#10b981"/>}>
                <select name="district_id" className="premium-select" value={formData.district_id || ""} onChange={handleChange} required>
                    <option value="">Select district</option>
                    {districts.map((d) => (<option key={d.id} value={d.id}>{d.name}</option>))}
                </select>
            </Field>

            <Field label="Nationality *" icon={<FaGlobe color="#10b981"/>}>
                <select name="nationality_id" className="premium-select" value={formData.nationality_id || ""} onChange={handleChange} required>
                    <option value="">Select nationality</option>
                    {nationalities.map((n) => (<option key={n.id} value={n.id}>{n.name}</option>))}
                </select>
            </Field>

            <Field label="Country *" icon={<FaGlobe color="#10b981"/>}>
                <select name="country_id" className="premium-select" value={formData.country_id || ""} onChange={handleChange} required>
                    <option value="">Select country</option>
                    {countries
                        .filter((c) => c.name.toLowerCase().includes("sri lanka"))
                        .map((c) => (<option key={c.id} value={c.id}>{c.name}</option>))}
                </select>
            </Field>

            <Field label="Gender *" icon={<FaVenusMars color="#10b981"/>}>
                <select name="gender_id" className="premium-select" onChange={handleChange} required>
                    <option value="">Select gender</option>
                    {genders.map((g) => (<option key={g.id} value={g.id}>{g.name}</option>))}
                </select>
            </Field>

            <Field label="Referral Code" icon={<FaIdCard color="#10b981"/>}>
                <input type="text" name="referral_code" className="premium-input" placeholder="Optional" value={formData.referral_code} onChange={handleChange} />
            </Field>

            <Field label="" fullWidth>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                    <div>
                        <input type="file" id="nicFront" name="nicFront" accept="image/*,.pdf" required style={{ display: "none" }} onChange={handleFileChange} />
                        <label htmlFor="nicFront" className="premium-file-label"><FaFileImage size={20} color="#3b82f6"/> <span style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{nicFrontName || "Upload NIC Front *"}</span></label>
                    </div>
                    <div>
                        <input type="file" id="nicBack" name="nicBack" accept="image/*,.pdf" required style={{ display: "none" }} onChange={handleFileChange} />
                        <label htmlFor="nicBack" className="premium-file-label"><FaFileImage size={20} color="#3b82f6"/> <span style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{nicBackName || "Upload NIC Back *"}</span></label>
                    </div>
                </div>
            </Field>

            <Field label="" fullWidth>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                    <div>
                        <input type="file" id="billFront" name="billFront" accept="image/*,.pdf" required style={{ display: "none" }} onChange={handleFileChange} />
                        <label htmlFor="billFront" className="premium-file-label"><FaFilePdf size={20} color="#eab308"/> <span style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{billFrontName || "Upload Bill Front *"}</span></label>
                    </div>
                    <div>
                        <input type="file" id="billBack" name="billBack" accept="image/*,.pdf" required style={{ display: "none" }} onChange={handleFileChange} />
                        <label htmlFor="billBack" className="premium-file-label"><FaFilePdf size={20} color="#eab308"/> <span style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{billBackName || "Upload Bill Back *"}</span></label>
                    </div>
                </div>
            </Field>
            
            <Field label="" fullWidth>
                <div>
                    <input type="file" id="businessRegistration" name="businessRegistration" accept=".pdf,.jpg,.png" style={{ display: "none" }} onChange={handleFileChange} />
                    <label htmlFor="businessRegistration" className="premium-file-label"><FaFilePdf size={20} color="#8b5cf6"/> <span style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{registrationName || "Upload Qualification (Optional)"}</span></label>
                </div>
            </Field>
        </div>
    </>
);

// 3. Fields for Hotel Owner
const HotelOwnerFields = ({
    formData,
    nationalities,
    countries,
    genders,
    propertyTypes,
    districts,
    logoName,
    registrationName,
    nicFrontName,
    nicBackName,
    billFrontName,
    billBackName,
    handleChange,
    handleFileChange
}) => (
    <>
        <style>{modernStyles}</style>
        <div className="premium-form-grid">
            <Field label="Business Name *" icon={<FaBuilding color="#f59e0b"/>} fullWidth>
                <input type="text" name="business_name" className="premium-input" placeholder="e. g. Cinnamon Grand" onChange={handleChange} required />
            </Field>
            
            <Field label="Business Owner Name *" icon={<FaUser color="#f59e0b"/>}>
                <input type="text" name="full_name" className="premium-input" placeholder="Owner name" onChange={handleChange} required />
            </Field>

            <Field label="Business Email *" icon={<FaEnvelope color="#f59e0b"/>}>
                <input type="email" name="email" className="premium-input" placeholder="cinnamon@example.com" onChange={handleChange} required />
            </Field>

            <Field label="Phone Number *" icon={<FaPhone color="#f59e0b"/>}>
                <div className="phone-input-wrapper">
                    <select className="premium-select"><option value="+94">SL +94</option></select>
                    <input type="tel" name="phone_number" className="premium-input" placeholder="Phone number" onChange={handleChange} required />
                </div>
            </Field>
            
            <Field label="Password *" icon={<FaLock color="#f59e0b"/>}>
                <input type="password" name="password" className="premium-input" placeholder="Password" onChange={handleChange} required />
            </Field>

            <Field label="Address *" icon={<FaMapMarkerAlt color="#f59e0b"/>} fullWidth>
                <input type="text" name="address" className="premium-input" placeholder="Hotel location" onChange={handleChange} required />
            </Field>

            <Field label="City *" icon={<FaBuilding color="#f59e0b"/>}>
                <input type="text" name="city" className="premium-input" placeholder="City" onChange={handleChange} required />
            </Field>

            <Field label="Zip Code *" icon={<FaMap color="#f59e0b"/>}>
                <input type="text" name="zip_code" className="premium-input" placeholder="Zip code" onChange={handleChange} required />
            </Field>

            <Field label="District *" icon={<FaMapMarkerAlt color="#f59e0b"/>}>
                <select name="district_id" className="premium-select" value={formData.district_id || ""} onChange={handleChange} required>
                    <option value="">Select district</option>
                    {districts.map((d) => (<option key={d.id} value={d.id}>{d.name}</option>))}
                </select>
            </Field>

            <Field label="Property Type *" icon={<FaBuilding color="#f59e0b"/>}>
                <select name="property_type_id" className="premium-select" value={formData.property_type_id || ""} onChange={handleChange} required>
                    <option value="">Select property type</option>
                    {propertyTypes.map((p) => (<option key={p.id} value={p.id}>{p.name}</option>))}
                </select>
            </Field>

            <Field label="National ID *" icon={<FaIdCard color="#f59e0b"/>}>
                <input type="text" name="national_id" className="premium-input" placeholder="Owner NIC" onChange={handleChange} required />
            </Field>
            
            <Field label="Date of Birth *" icon={<FaCalendar color="#f59e0b"/>}>
                <input type="date" name="dob" className="premium-input" onChange={handleChange} required />
            </Field>

            <Field label="Gender *" icon={<FaVenusMars color="#f59e0b"/>}>
                <select name="gender_id" className="premium-select" value={formData.gender_id || ""} onChange={handleChange} required>
                    <option value="">Select gender</option>
                    {genders.map((g) => (<option key={g.id} value={g.id}>{g.name}</option>))}
                </select>
            </Field>

            <Field label="Country *" icon={<FaGlobe color="#f59e0b"/>}>
                <select name="country_id" className="premium-select" value={formData.country_id || ""} onChange={handleChange} required>
                    <option value="">Select country</option>
                    {countries
                        .filter((c) => c.name.toLowerCase().includes("sri lanka"))
                        .map((c) => (<option key={c.id} value={c.id}>{c.name}</option>))}
                </select>
            </Field>

            <Field label="Nationality *" icon={<FaGlobe color="#f59e0b"/>}>
                <select name="nationality_id" className="premium-select" value={formData.nationality_id || ""} onChange={handleChange} required>
                    <option value="">Select nationality</option>
                    {nationalities.map((n) => (<option key={n.id} value={n.id}>{n.name}</option>))}
                </select>
            </Field>

            <Field label="Referral Code" icon={<FaIdCard color="#f59e0b"/>}>
                <input type="text" name="referral_code" className="premium-input" placeholder="Optional" value={formData.referral_code} onChange={handleChange} />
            </Field>

            <Field label="" fullWidth>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                    <div>
                        <input type="file" id="nicFront" name="nicFront" accept="image/*,.pdf" required style={{ display: "none" }} onChange={handleFileChange} />
                        <label htmlFor="nicFront" className="premium-file-label"><FaFileImage size={20} color="#3b82f6"/> <span style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{nicFrontName || "Upload NIC Front *"}</span></label>
                    </div>
                    <div>
                        <input type="file" id="nicBack" name="nicBack" accept="image/*,.pdf" required style={{ display: "none" }} onChange={handleFileChange} />
                        <label htmlFor="nicBack" className="premium-file-label"><FaFileImage size={20} color="#3b82f6"/> <span style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{nicBackName || "Upload NIC Back *"}</span></label>
                    </div>
                </div>
            </Field>

            <Field label="" fullWidth>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                    <div>
                        <input type="file" id="billFront" name="billFront" accept="image/*,.pdf" required style={{ display: "none" }} onChange={handleFileChange} />
                        <label htmlFor="billFront" className="premium-file-label"><FaFilePdf size={20} color="#eab308"/> <span style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{billFrontName || "Upload Bill Front *"}</span></label>
                    </div>
                    <div>
                        <input type="file" id="businessRegistration" name="businessRegistration" accept=".pdf,.jpg,.png" style={{ display: "none" }} onChange={handleFileChange} />
                        <label htmlFor="businessRegistration" className="premium-file-label"><FaFilePdf size={20} color="#8b5cf6"/> <span style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{registrationName || "Business Res (Optional)"}</span></label>
                    </div>
                </div>
            </Field>
        </div>
    </>
);

function RoleSpecificFields(props) {
    const { role } = props;

    switch (role) {
        case "Traveler":
            return <TravelerFields {...props} />;
        case "Guide":
            return <GuideFields {...props} />;
        case "Hotel Owner":
            return <HotelOwnerFields {...props} />;
        default:
            return null;
    }
}

export default RoleSpecificFields;